module.exports = __webpack_public_path__ + "img/vision_mission.966759fc.jpg";